import { useActionData } from '@remix-run/react';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';

interface Props {
  children: React.ReactNode;
  handleRedirect: () => void;
}

const Continue = ({ children, handleRedirect }: Props) => {
  const { t } = useTranslation();
  const actionData = useActionData();

  useEffect(() => {
    if (actionData?.status === 'success') {
      if (actionData?.toast?.message) toast.success(actionData?.toast?.message);
      handleRedirect();
    }
  }, [actionData]);

  return (
    <div className="sticky bottom-0 left-0 right-0 mx-auto mt-4 w-full max-w-3xl bg-white pb-8 pt-4">
      <div className="absolute -top-8 right-0 -z-10 h-8 w-full bg-white blur-lg" />
      <div className="absolute -top-4 right-0 -z-10 h-8 w-full bg-white blur" />
      <div className="space-y-4 bg-white">
        <div>
          <Button variant={'primary'} className="!rounded-md text-lg" type="submit" block>
            {children}
          </Button>
        </div>
        <div className="text-center text-sm text-gray-900">
          <button type="button" onClick={handleRedirect} className="text-gray-900">
            {t('shared.cta.maybe_later')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Continue;
